<app-modal-base
  [title]="'share' | translate"
  [showCloseIcon]="true"
  [showPrimaryButton]="false"
  [showSecondaryButton]="false"
  [modalClass]="'flex justify-center'"
  [modalBodyClass]="'w-full'"
  (close)="dialogRef.close(false)"
>
  <div class="space-y-6">
    <!-- QR Code Section -->
    <div class="flex justify-center">
      <app-qr-code-handler-component
        [qrOptions]="{
          qrData: getProfileUrl(),
          ariaLabel: 'Nicky Share QR-code',
          alt: 'Nicky Share QR-code',
        }"
        [errorLabel]="'ERROR.sorryQrCodeGeneration'"
        id="share-qr-code"
      ></app-qr-code-handler-component>
    </div>

    <!-- Input Section -->
    <div class="space-y-4" id="profile-link-container">
      <label class="block text-sm font-medium text-gray-700">
        {{ 'public_profile.copyProfileLink' | translate }}
      </label>
      <div
        class="flex items-center border border-gray-300 rounded-lg p-2 hover:border-blue-500 cursor-pointer"
        (click)="copyProfileUrl()"
        id="profile-link"
      >
        <i id="copy-link" class="ph ph-copy text-gray-500 mr-2"></i>
        <input
          [disabled]="true"
          type="text"
          [value]="getProfileUrl()"
          class="flex-1 bg-transparent outline-none text-gray-700 remove-default-input-style"
        />
      </div>
    </div>
  </div>
</app-modal-base>
